var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigPaperErrorTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 7.99967C14.6668 11.6823 11.6822 14.6663 8.00016 14.6663C4.31816 14.6663 1.3335 11.6823 1.3335 7.99967C1.3335 4.31834 4.31816 1.33301 8.00016 1.33301C11.6822 1.33301 14.6668 4.31834 14.6668 7.99967Z",
    fill: "#eb5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58024 8.42062C8.58024 8.74196 8.31824 9.00396 7.99691 9.00396C7.67557 9.00396 7.41357 8.74196 7.41357 8.42062V5.47396C7.41357 5.15262 7.67557 4.89062 7.99691 4.89062C8.31824 4.89062 8.58024 5.15262 8.58024 5.47396V8.42062ZM7.41691 10.5358C7.41691 10.2145 7.67757 9.95249 7.99691 9.95249C8.32557 9.95249 8.58691 10.2145 8.58691 10.5358C8.58691 10.8572 8.32557 11.1192 8.00357 11.1192C7.68024 11.1192 7.41691 10.8572 7.41691 10.5358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigPaperErrorTag);
export default __webpack_public_path__ + "static/media/jobconfig-paper-errorTag.782749a57c9b5186773cc59b9bf055fa.svg";
export { ForwardRef as ReactComponent };